import React from 'react';
import {
  Atom,
  type AtomRenderProps,
  type StyleAttributeObject,
} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const emptyObject: Record<string, any> = {};

const setDisplayBlock = (style: StyleAttributeObject) => {
  if (style.display === 'block') {
    return style;
  }
  return {
    ...style,
    display: 'block',
  };
};

const FormSuccessMessage = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const successMessageClasses = classes.push('w-form-done');

    const props = generateAttributes(attributes, successMessageClasses);
    const finalProps =
      context.get('formState') === 'success'
        ? {
            ...props,
            style: setDisplayBlock(props.style || emptyObject),
          }
        : props;

    return (
      <div {...finalProps}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Success Message',
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'The display setting can’t be changed for a form’s success message.',
    },
  },
  render: FormSuccessMessage,
  fields: {children: TListOfElement},
});

export default config;
